module.exports = __webpack_public_path__ + "static/img/fail-icon.184b123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/fail-icon.png
// module id = PLyF
// module chunks = 215